import { useClockTimestamp } from '@/components/utils/clock/useClockTimestamp'
import { dayjs } from '@/lib/dayjs'
import { useCallback, useState } from 'react'

export function useTimeout(timeoutValue: number): [number, boolean, () => void] {
  const [checkpoint, setCheckpoint] = useState(dayjs())
  const now = useClockTimestamp()

  const remainingTime = timeoutValue - now.diff(checkpoint)
  const timeout = now.diff(checkpoint) > timeoutValue
  const resetTimeout = useCallback(() => setCheckpoint(dayjs()), [])

  return [remainingTime, timeout, resetTimeout]
}
